// React i hooks
import { NavLink } from "react-router-dom";
import { memo } from "react";

// Helpers
import { classNames } from "helpers";

// Moduli specifični za projekt
import { Routes as SettingRoutes } from "ui/modules/navigation";

// Tipovi i konstante
import { PricingTabMenuProps } from "./types";

/*
  Samo cjenik. Tenanti, prijevodi, postavke i nadzorna ploča su zasebni ekrani i do njih se
  dolazi bočnim izbornikom — vodoravni izbornik koji ih sve ponavlja samo je duplicirao
  navigaciju.
*/
const TABS: { to: string; label: string }[] = [
  { to: SettingRoutes.PricingPageRouter, label: "Cjenik" },
  { to: SettingRoutes.PricingSchemesPageRouter, label: "Cjenovne grupe" },
  { to: SettingRoutes.PricingDeviationsPageRouter, label: "Posebni uvjeti" },
];

/** Vodoravni izbornik triju ekrana cjenika. */
const PricingTabMenu: React.FC<PricingTabMenuProps> = () => {
  return (
    <div className="flex border-b border-slate-200 bg-white overflow-x-auto">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive ? "text-sky-600 border-b-2 border-b-sky-600" : "text-gray-600",
              "font-semibold px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  );
};

export default memo(PricingTabMenu);
